
/* injects from baggage-loader */

'use strict';

import bg from '_images/bg.png';

export default class DialogInterventionalController {
    constructor($log, $state, Dialog, Session, Trophies) {
        'ngInject';
        this.$log = $log;
        this.$state = $state;
        this.bg = bg;
        this.Dialog = Dialog;
        this.Session = Session;
        this.Trophies = Trophies;
       
        //this.ballonIndex = 1;
        this.ballonIndex = 0;
        this.confirmDialog = false;
    }    

    foward(){

        
        this.ballonIndex = this.ballonIndex + 1; 
        // if(this.resolve.ballons[this.ballonIndex+1] === "confirmation"){
            
        //     this.confirmDialog = true;
        // }else{
        //   this.ballonIndex = this.ballonIndex + 1;  
        // }

        
    }
    end(){
        this.confirmDialog = this.resolve.ballons.confirmation;
    }
    goTo(route){
        this.modalInstance.close(true);
        this.$state.go(route);
    }
    ok(){
      
        this.modalInstance.close(true);
        let stagesComplete = this.Session.getTaskOne();


        if(stagesComplete === 3 && this.Trophies.getNumberThrophies() < 6){
            this.toStagesMenu();

        }
    }

    cancel(){
      this.modalInstance.dismiss('cancel');
    }

    toStagesMenu(){
        this.Dialog.showStagesModal( () => {
            this.$log.log('Close Menu');
        });
    }
}


// WEBPACK FOOTER //
// ./src/app/components/dialogs/interventional/interventional.controller.js